/**
 * Created by RKL on 13/08/2015.
 */
define('mbSmpMatDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'mbSmpMatDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var MbSmpMatDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showMbSmpMatInfo(data);
    },

    showMbSmpMatInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('mbSmpMatDetailTab').show(view);
    }
  };

  module.exports = MbSmpMatDetailTabController;
});
